<div
  class="qc-summary-container"
  [class.print-mode]="isPrintMode"
  [class.print-view]="isPrintView"
  [class.force-repaint]="forceRepaint">
  <div class="qc-summary-body">
    <div class="qc-summary-scroll bpx-report" #qcSummaryScroll>
      @if (isPrintView) {
      <app-print-preview-bar
        viewName="QC Summary"
        [studyName]="studyName"
        [contextLine]="printContextLine"
        [tableColumns]="tableColumns"
        (selectColumns)="handlePrintColumnSelection($event)"></app-print-preview-bar>
      }
      <!--
        The printed report keeps its plain stacked identification block; on screen the same five
        values read as a card, matching the identification blocks on the other tabs.
      -->
      @if (isPrintView) {
      <div class="bpx-print-only">
        <div class="qc-summary-meta">
          Panel Name: <span>{{ panelName || '-' }}</span><br />
          Run Type: <span>{{ runType || '-' }}</span><br />
          Test Spec: <span>{{ testSpec || '-' }}</span><br />
          Assignment Spec: <span>Final</span><br />
          Operator: <span>{{ operatorName || '-' }}</span>
        </div>
      </div>

      <div class="bpx-detail qc-summary-detail bpx-screen-only">
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Panel Name</span>
          <span class="bpx-detail__value">{{ panelName || '-' }}</span>
        </div>
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Run Type</span>
          <span class="bpx-detail__value">{{ runType || '-' }}</span>
        </div>
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Test Spec</span>
          <span class="bpx-detail__value">{{ testSpec || '-' }}</span>
        </div>
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Assignment Spec</span>
          <span class="bpx-detail__value">Final</span>
        </div>
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Operator</span>
          <span class="bpx-detail__value">{{ operatorName || '-' }}</span>
        </div>
      </div>
      } @else {
      <div class="bpx-detail qc-summary-detail">
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Panel Name</span>
          <span class="bpx-detail__value">{{ panelName || '-' }}</span>
        </div>
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Run Type</span>
          <span class="bpx-detail__value">{{ runType || '-' }}</span>
        </div>
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Test Spec</span>
          <span class="bpx-detail__value">{{ testSpec || '-' }}</span>
        </div>
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Assignment Spec</span>
          <span class="bpx-detail__value">Final</span>
        </div>
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Operator</span>
          <span class="bpx-detail__value">{{ operatorName || '-' }}</span>
        </div>
      </div>
      }
      <div class="toggle-links-box" *ngIf="!isPrintView">
        <button type="button" class="bpx-btn" [disabled]="(isStudySaved$ | async) !== true" (click)="navigateToPrintView()">
          <mat-icon fontIcon="print"></mat-icon>
          <span>Print View</span>
        </button>
      </div>

      @if (isPrintView && isPrintMode) {
      @for (pageColumns of printPages; track trackByPage; let pageIndex = $index) {
      <div class="bpx-print-page" [class.bpx-print-page--last]="pageIndex === (printPages.length - 1)">
        @if (printPageCaption(pageIndex)) {
        <div class="bpx-print-page-caption">{{ printPageCaption(pageIndex) }}</div>
        }
        <ng-container *ngTemplateOutlet="qcSummaryTable; context: { $implicit: pageColumns }"></ng-container>
      </div>
      }
      } @else {
        <ng-container *ngTemplateOutlet="qcSummaryTable; context: { $implicit: columns }"></ng-container>
      }

      <ng-template #qcSummaryTable let-pageColumns>
      <table class="bpx-report__table bpx-report__table--pin-first bpx-report__table--sticky-head qc-summary-table">
        <thead class="bpx-report__head">
          <tr class="section-header">
            <td class="row-label row-label--split">
              <div class="row-label__left">General Information</div>
              <div class="row-label__right">SPS Name</div>
            </td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)">{{ panelName || '-' }}</td>
            </ng-container>
          </tr>
          <tr>
            <td class="row-label">KitLot#</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)">
                {{ displayOrDash(column.reportContentItems.lot) }}
                <span *ngIf="column.valueAssigned === 'AdjustedCalculate'" class="block">{{ adjustedLabel }}</span>
              </td>
            </ng-container>
          </tr>
          <tr>
            <td class="row-label">Run ID</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)">{{ displayOrDash(column.reportContentItems.runId) }}</td>
            </ng-container>
          </tr>
          <tr>
            <td class="row-label">Assay Name</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)">{{ displayOrDash(column.reportContentItems.assay) }}</td>
            </ng-container>
          </tr>
          <tr>
            <td class="row-label">Bead Region</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)">{{ displayOrDash(column.reportContentItems.region) }}</td>
            </ng-container>
          </tr>
          <tr>
            <td class="row-label">Units</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)">{{ getUnitsForColumn(column) }}</td>
            </ng-container>
          </tr>
          <tr>
            <td class="row-label">Result Decimal Precision</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)">{{ displayOrDash(column.reportContentItems.resultDecimalPrecision) }}</td>
            </ng-container>
          </tr>
          <tr>
            <td class="row-label">Run Date</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)">{{ displayOrDash(getRunDate()) }}</td>
            </ng-container>
          </tr>
          <tr>
            <td class="row-label">Calibrator Lot</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)">{{ displayOrDash(getCalibratorLot()) }}</td>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let level of controlQcLevels">
            <ng-container *ngFor="let metric of qcMetrics; let i = index">
              <tr
                class="qc-metric-row"
                [class.qc-metric-barcode]="metric === 'BarCode'"
                [class.qc-metric-mean]="metric === 'Mean'"
                [class.qc-metric-sd]="metric === 'SD'"
                [class.qc-metric-n]="metric === 'N'">
                <td class="row-label row-label--split">
                  <span
                    class="section-tag"
                    [class.section-spacer]="!(level === controlQcLevels[0] && i === 0)">
                    Control QC -
                  </span>
                  <span class="row-label__right">
                    <span class="level-tag" [class.level-spacer]="i !== 0">Level {{ level }}</span>
                    <span class="metric-tag">{{ getLevelMetricLabel(level, metric) }}</span>
                  </span>
                </td>
                <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                  <td [ngClass]="getColumnClasses(column)" [class.placeholder-cell]="metric === 'SD' || metric === 'N'">
                    {{ getControlQcMetricValue(column, level, metric) }}
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container>
          <tr class="section-subheader qc-block-header bpx-report__section">
            <td class="row-label">Control Range Criteria (Pass/Fail)</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlQcLevels">
            <tr class="qc-block-row">
              <td class="row-label">
                <span class="level-tag">Level {{ level }}</span>
              </td>
              <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                <td [ngClass]="getColumnClasses(column)">
                  <ng-container *ngIf="getControlQcCriteria(column, level) as criteria">
                    <span *ngIf="criteria !== '-'">±{{ criteria }}</span>
                    <span *ngIf="criteria === '-'">-</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <tr class="section-subheader qc-block-header bpx-report__section">
            <td class="row-label">Control Ranges (Pass/Fail)</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlQcLevels">
            <tr class="qc-block-row">
              <td class="row-label">
                <span class="level-tag">Level {{ level }}</span>
              </td>
              <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                <td [ngClass]="getColumnClasses(column)">{{ getControlQcRange(column, level) }}</td>
              </ng-container>
            </tr>
          </ng-container>
          <tr class="section-subheader qc-block-header bpx-report__section">
            <td class="row-label">Control Result (Pass/Fail)</td>
            <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
              <td [ngClass]="getColumnClasses(column)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlQcLevels">
            <tr class="qc-block-row">
              <td class="row-label">
                <span class="level-tag">Level {{ level }}</span>
              </td>
              <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                <td [ngClass]="getColumnClasses(column)">
                  <ng-container *ngIf="getControlQcStatus(column, level) as qcStatus">
                    <span *ngIf="qcStatus !== '-'" [ngClass]="getStatusClassFromResult(qcStatus)">
                      {{ qcStatus | uppercase }}
                    </span>
                    <span *ngIf="qcStatus === '-'">-</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>

          <ng-container *ngIf="controlTestLots.length; else noControlTest">
            <ng-container *ngFor="let lot of controlTestLots; let lotIndex = index">
              <ng-container *ngFor="let level of controlTestLevels">
                <ng-container *ngFor="let metric of testMetrics; let i = index">
                  <tr
                    class="qc-metric-row"
                    [class.qc-metric-barcode]="metric === 'BarCode'"
                    [class.qc-metric-mean]="metric === 'Mean'"
                    [class.qc-metric-sd]="metric === 'SD'"
                    [class.qc-metric-n]="metric === 'N'">
                    <td class="row-label row-label--split">
                      <span
                        class="section-tag"
                        [class.section-spacer]="!(level === controlTestLevels[0] && i === 0)">
                        Control Test - {{ lotIndex + 1 }}
                      </span>
                      <span class="row-label__right">
                        <span class="level-tag" [class.level-spacer]="i !== 0">Level {{ level }}</span>
                        <span class="metric-tag">{{ getLevelMetricLabelForTest(level, metric) }}</span>
                      </span>
                    </td>
                    <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                      <td [ngClass]="getColumnClasses(column)" [class.placeholder-cell]="metric === 'SD' || metric === 'N'">
                        {{ getControlTestMetricValue(column, lot, level, metric) }}
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
              <tr class="section-subheader qc-block-header bpx-report__section">
                <td class="row-label">Control Range Criteria (Alert)</td>
                <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                  <td [ngClass]="getColumnClasses(column)"></td>
                </ng-container>
              </tr>
              <ng-container *ngFor="let level of controlTestLevels">
                <tr class="qc-block-row">
                  <td class="row-label">
                    <span class="level-tag">Level {{ level }}</span>
                  </td>
                  <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                    <td [ngClass]="getColumnClasses(column)">
                      <ng-container *ngIf="getControlTestCriteriaAlert(column, lot, level) as criteria">
                        <span *ngIf="criteria !== '-'">±{{ criteria }}</span>
                        <span *ngIf="criteria === '-'">-</span>
                      </ng-container>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
              <tr class="section-subheader qc-block-header bpx-report__section">
                <td class="row-label">Control Ranges (Alert)</td>
                <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                  <td [ngClass]="getColumnClasses(column)"></td>
                </ng-container>
              </tr>
              <ng-container *ngFor="let level of controlTestLevels">
                <tr class="qc-block-row">
                  <td class="row-label">
                    <span class="level-tag">Level {{ level }}</span>
                  </td>
                  <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                    <td [ngClass]="getColumnClasses(column)">{{ getControlTestRangeAlert(column, lot, level) }}</td>
                  </ng-container>
                </tr>
              </ng-container>
              <tr class="section-subheader qc-block-header bpx-report__section">
                <td class="row-label">Control Result (Alert)</td>
                <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                  <td [ngClass]="getColumnClasses(column)"></td>
                </ng-container>
              </tr>
              <ng-container *ngFor="let level of controlTestLevels">
                <tr class="qc-block-row">
                  <td class="row-label">
                    <span class="level-tag">Level {{ level }}</span>
                  </td>
                  <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                    <td [ngClass]="getColumnClasses(column)">
                      <ng-container *ngIf="getControlTestStatusAlert(column, lot, level) as alertStatus">
                        <span *ngIf="alertStatus !== '-'" [ngClass]="getStatusClassFromResult(alertStatus)">
                          {{ alertStatus | uppercase }}
                        </span>
                        <span *ngIf="alertStatus === '-'">-</span>
                      </ng-container>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
              <tr class="section-subheader qc-block-header bpx-report__section">
                <td class="row-label">Control Range Criteria (Pass/Fail)</td>
                <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                  <td [ngClass]="getColumnClasses(column)"></td>
                </ng-container>
              </tr>
              <ng-container *ngFor="let level of controlTestLevels">
                <tr class="qc-block-row">
                  <td class="row-label">
                    <span class="level-tag">Level {{ level }}</span>
                  </td>
                  <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                    <td [ngClass]="getColumnClasses(column)">
                      <ng-container *ngIf="getControlTestCriteriaPass(column, lot, level) as criteria">
                        <span *ngIf="criteria !== '-'">±{{ criteria }}</span>
                        <span *ngIf="criteria === '-'">-</span>
                      </ng-container>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
              <tr class="section-subheader qc-block-header bpx-report__section">
                <td class="row-label">Control Ranges (Pass/Fail)</td>
                <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                  <td [ngClass]="getColumnClasses(column)"></td>
                </ng-container>
              </tr>
              <ng-container *ngFor="let level of controlTestLevels">
                <tr class="qc-block-row">
                  <td class="row-label">
                    <span class="level-tag">Level {{ level }}</span>
                  </td>
                  <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                    <td [ngClass]="getColumnClasses(column)">{{ getControlTestRangePass(column, lot, level) }}</td>
                  </ng-container>
                </tr>
              </ng-container>
              <tr class="section-subheader qc-block-header bpx-report__section">
                <td class="row-label">Control Result (Pass/Fail)</td>
                <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                  <td [ngClass]="getColumnClasses(column)"></td>
                </ng-container>
              </tr>
              <ng-container *ngFor="let level of controlTestLevels">
                <tr class="qc-block-row">
                  <td class="row-label">
                    <span class="level-tag">Level {{ level }}</span>
                  </td>
                  <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                    <td [ngClass]="getColumnClasses(column)">
                      <ng-container *ngIf="getControlTestStatusPass(column, lot, level) as passStatus">
                        <span *ngIf="passStatus !== '-'" [ngClass]="getStatusClassFromResult(passStatus)">
                          {{ passStatus | uppercase }}
                        </span>
                        <span *ngIf="passStatus === '-'">-</span>
                      </ng-container>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-template #noControlTest>
            <tr class="section-header bpx-report__section">
              <td class="row-label">Control Test -</td>
              <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                <td [ngClass]="getColumnClasses(column)"></td>
              </ng-container>
            </tr>
            <tr>
              <td class="row-label">No Control Test Data</td>
              <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
                <td [ngClass]="getColumnClasses(column)">-</td>
              </ng-container>
            </tr>
          </ng-template>
        </tbody>
        <tfoot class="bpx-print-spacer-footer">
          <tr>
            <td [attr.colspan]="(pageColumns.length || 0) + 1">
              <div class="bpx-print-footer-spacer" aria-hidden="true"></div>
            </td>
          </tr>
        </tfoot>
      </table>
      </ng-template>
    </div>
  </div>
  @if (isPrintView) {
  <div class="qc-summary-print-footer">
    <div>{{ studyName || '-' }}</div>
    <div>{{ panelName || '-' }} : Spec Rev {{ specVersion || '-' }}</div>
    <div>Web App Version: {{ appVersion || '-' }}</div>
  </div>
  }
</div>
